import { render, staticRenderFns } from "./pageLeft.vue?vue&type=template&id=67208486&scoped=true&"
import script from "./pageLeft.vue?vue&type=script&lang=js&"
export * from "./pageLeft.vue?vue&type=script&lang=js&"
import style0 from "./pageLeft.vue?vue&type=style&index=0&id=67208486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67208486",
  null
  
)

export default component.exports